import { Routes } from '@angular/router';
import { DocsPage } from './pages/docs/docs';
import { HomePage } from './pages/home/home';
import { LoginPage } from './pages/login/login';
import { PaymentPage } from './pages/payment/payment';
import { ResetPasswordPage } from './pages/reset-password/reset-password';
import { App } from './app';

export const routes: Routes = [
  { path: 'docs', component: DocsPage },
  { path: 'docs/:feature', component: DocsPage },
  { path: 'home', component: HomePage },
  { path: 'home/pricing', component: HomePage },
  { path: 'home/privacy-policy', component: HomePage },
  { path: 'home/terms', component: HomePage },
  { path: 'login', component: LoginPage },
  { path: 'payment', component: PaymentPage },
  { path: 'reset-password', component: ResetPasswordPage },
  // Room invite links: /room/XXXX
  // Uses a plain path segment - no special characters that get encoded by browsers,
  // messaging apps (WhatsApp, Slack, Discord) or CDNs. The old /room=XXXX format
  // caused '=' to be encoded as '%3D' which broke routing entirely.
  { path: 'room/:roomId', component: App },
  { path: '**', redirectTo: '' },
];